import React, {useState, useEffect} from 'react';
import styled, { keyframes } from 'styled-components'
import axiosInstance from './../index';
import appLogo from './../rumx-logo.png';

const QUERY_RATING_URL = `https://us-central1-rumtastingnotes.cloudfunctions.net/rumx-rating-query`;

function RumxRating(props) {
    const [rating, setRating] = useState({
        median_rating: '--',
        ratings_count: '--',
        url: '--',
        loading: true,
        error: false
    });

    useEffect(() => {
        axiosInstance.get(QUERY_RATING_URL, {
            params: {
                rumxid: props.rumxid,
                ean: props.ean
            }
        }).then((result) => {
            console.log(result);
            if (result.status != 200) {
                setRating({
                    median_rating: '',
                    ratings_count: '',
                    url: '',
                    loading: false,
                    error: true
                });
            } else {
                const ratingResult = result.data;
                setRating({
                    median_rating: ratingResult.median,
                    ratings_count: ratingResult.rating_count,
                    url: ratingResult.url,
                    loading: false,
                    error: false
                });
            }
        });
    }, []);

    const loadingAnimation = keyframes`
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    `

    const LoadingSpinner = styled.div`
        border: 5px solid #f3f3f3; /* Light grey */
        border-top: 5px solid #222C2E;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation-name: ${loadingAnimation};
        animation-duration: 2s;
        animation-iteration-count: infinite;
    `

    if (rating.loading) {
        if (rating.error) {
            return (<div id="rumx-no-results"></div>)
        }

        return (<LoadingSpinner class="loader"></LoadingSpinner>);
    }

    const hideRating = props.hideRating == 'true';

    const RatingBaseContainer = styled.div`
        font-family: "Oswald", sans-serif;
        border-radius: 10px;
        background-color: #222C2E;
        color: white;
        padding-left: ${hideRating ? "10px" : "15px"};
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: ${hideRating ? "5px" : "10px"};
        display: inline-block;
    `

    const AppLogoImg = styled.img`
        height: ${hideRating ? "23px" : "20px"};
        ${props => { if (!props.hideRating) {
            return `
                margin-left: 20px;
                padding-top: 5px;
                height: 1.4em;
            `
            } else {
                return `
                padding-top: 5px;
            `
            } }}
    `

    const RatingLogoContainer = styled.div`
        display: flex;
    `

    const SubText = styled.p`
        font-size: 13px;
        margin: 0px;
        letter-spacing: 1px;
    `

    const WebsiteLink = styled.a`
        text-decoration: none;
    `

    const MedianRating = styled.span`
        font-size: 22px;
        font-weight: 600;
    `

    const MedianRatingMax = styled.span`
        color: #DEDEDE;
        font-weight: 400;
    `

    const RatingCount = styled.span`
        margin-top: -3px;
    `

    if (hideRating) {
        return (
            <WebsiteLink href={rating.url} target="_blank">
                <RatingBaseContainer hideRating={hideRating}>
                    <SubText><RatingCount>{rating.ratings_count} ratings</RatingCount></SubText>
                    <AppLogoImg hideRating={hideRating} src={appLogo} alt="RumX logo"></AppLogoImg>
                </RatingBaseContainer>
            </WebsiteLink>
        );
    } else {
        return (
            <WebsiteLink href={rating.url} target="_blank">
                <RatingBaseContainer hideRating={hideRating}>
                    <RatingLogoContainer>
                        <SubText><MedianRating>{rating.median_rating}</MedianRating><MedianRatingMax>/100</MedianRatingMax></SubText>
                        <AppLogoImg hideRating={hideRating} src={appLogo} alt="RumX logo"></AppLogoImg>
                    </RatingLogoContainer>
                    <SubText><RatingCount>{rating.ratings_count} ratings</RatingCount></SubText>
                </RatingBaseContainer>
            </WebsiteLink>
        );
    }
}

export default RumxRating;